import { render, staticRenderFns } from "./PremangePatientList.vue?vue&type=template&id=dcc220d4&scoped=true"
import script from "./PremangePatientList.vue?vue&type=script&lang=js"
export * from "./PremangePatientList.vue?vue&type=script&lang=js"
import style0 from "./PremangePatientList.vue?vue&type=style&index=0&id=dcc220d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc220d4",
  null
  
)

export default component.exports